/** Hatch on a reservation bar when purchased coverage has under one buffer day. */

export const BUFFER_DAY_SECONDS = 24 * 3600;

export function insuranceBufferStripe(startUnix, endUnix, coverageEndsUnix) {
  const start = Number(startUnix);
  const end = Number(endUnix);
  const coverage = Number(coverageEndsUnix);
  if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(coverage)) return null;
  if (!(end > start) || !(coverage > 0)) return null;
  const warningStart = coverage - BUFFER_DAY_SECONDS;
  if (end <= warningStart) return null;
  const stripeStart = Math.max(start, warningStart);
  if (stripeStart >= end) return null;
  return {
    startUnix: stripeStart,
    endUnix: end,
    fraction: (stripeStart - start) / (end - start),
  };
}

export function hatchedBarStyle(baseStyle, fraction) {
  const base = (baseStyle && baseStyle.background) || "AquaMarine";
  const pct = Math.max(0, Math.min(100, Number(fraction) * 100));
  const hatch = "repeating-linear-gradient(-45deg, #6d28d9 0 4px, #ddd6fe 4px 8px)";
  const solid = "linear-gradient(90deg, " + base + " " + pct + "%, rgba(255,255,255,0) " + pct + "%)";
  return {
    ...(baseStyle || {}),
    background: solid + ", " + hatch,
  };
}
